import { useModalState, Text } from "@src/lib/ui-react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Link,
  List,
  ListItem,
  Skeleton,
  Stack,
} from "@mui/material";
import type { Dispatch } from "redux";
import { useGetFacilities } from "./useGetFacilities";
import { Close as CloseIcon } from "@mui/icons-material";

interface CorporateFacilitiesProps {
  parentFacility: {
    userId: string;
    name: string;
    salesforceID?: string;
  };
  switchToUserSession: (data: { userId: string }) => (dispatch: Dispatch) => void;
}
export function CorporateFacilities(props: CorporateFacilitiesProps) {
  const { switchToUserSession, parentFacility } = props;
  const corporateModalState = useModalState();
  const {
    data: childWorkplaces,
    isLoading: isGetFacilitiesLoading,
    isSuccess: isGetFacilitiesSuccess,
  } = useGetFacilities({
    "filter[parentFacilityId]": parentFacility.userId,
    limit: 1000,
  });

  return (
    <>
      <Link
        component="button"
        variant="body2"
        onClick={() => {
          corporateModalState.openModal();
        }}
      >
        {parentFacility.name}
      </Link>

      {corporateModalState.modalIsOpen && (
        <Dialog
          open={corporateModalState.modalIsOpen}
          onClose={() => {
            corporateModalState.closeModal();
          }}
          maxWidth="md"
          fullWidth
          scroll="paper"
          PaperProps={{ sx: { minWidth: 540 } }}
        >
          <DialogTitle>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Text variant="h3">Corporate Hierarchy</Text>

              <CloseIcon
                aria-label="Close"
                onClick={() => {
                  corporateModalState.closeModal();
                }}
              />
            </Stack>
          </DialogTitle>
          <DialogContent dividers>
            <Stack spacing={2}>
              <Stack direction="row">
                <Text variant="subtitle2" sx={{ width: "128px" }}>
                  Name:
                </Text>
                <Text variant="subtitle2">{parentFacility.name}</Text>
              </Stack>
              <Stack direction="row">
                <Text variant="subtitle2" sx={{ width: "128px" }}>
                  Salesforce Id:
                </Text>
                <Text variant="subtitle2">{parentFacility.salesforceID}</Text>
              </Stack>
              {isGetFacilitiesLoading ? (
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
              ) : undefined}
              {isGetFacilitiesSuccess ? (
                <Stack>
                  <Text variant="subtitle2">Facilities:</Text>
                  <List sx={{ listStyleType: "decimal", paddingLeft: 4 }}>
                    {childWorkplaces.map((facility) => (
                      <ListItem key={facility.userId} sx={{ display: "list-item" }} disablePadding>
                        <Link
                          component={Button}
                          onClick={() => switchToUserSession({ userId: facility.userId })}
                          sx={{ verticalAlign: "baseline" }}
                        >
                          {facility.name}
                        </Link>
                      </ListItem>
                    ))}
                  </List>
                </Stack>
              ) : undefined}
            </Stack>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
